/**
 * Render an unknown thrown value as a human-readable string. Prefers `.message`
 * when present, otherwise serializes own (incl. non-enumerable) properties so
 * Error fields survive JSON.stringify.
 */
export function stringifyError(err: any, preferMessage: boolean = true) {
  if (typeof err === "string") {
    return err;
  }
  if (preferMessage) {
    if (err.message) {
      return err.message;
    }
  }
  return JSON.stringify(err, Object.getOwnPropertyNames(err), 4);
}
